<template>
  <div class="favorites" :style="activeColor">
    <div class="favorites__container container">
      <div class="favorites__top">
        <h2 v-text="heading" />
      </div>
      <div class="favorites__slider swiper-container" ref="favoritesSlider">
        <div class="favorites__wrapper swiper-wrapper">
          <div class="favorites__slide swiper-slide" v-for="(favorite, f) in favoriteItems"
            :key="'favorite'+f">
            <div class="favorites__image favorite__image__wrapper" style="position: absolute; visibility: hidden;"></div>
             <div class="favorites__image media" >
              <router-link :to="favorite.link">
              <img :src="mediaPath(favorite.image)" :alt="$store.getters.page.title + ' ' + f" :title="$store.getters.page.title + ' ' + f" :style="{height:height + 'px'}"  loading="lazy"/>
              </router-link>
            </div>
            
            <div class="favorites__info">
              <div class="favorites__logo">
               <router-link :to="favorite.link">
                <img :src="mediaPath(favorite.logo)" :alt="$store.getters.page.title + ' ' + 'logo ' + f" :title="$store.getters.page.title + ' ' + 'logo ' + f" loading="lazy" />
                </router-link>
              </div>
              <div v-if="favorite.description" class="favorites__description"
                v-text="favorite.description" />
              <div class="favorites__footer">
                <router-link :to="favorite.link" tag="div" class="favorites__more more">
                  <span class="more__text" v-text="more_label" />
                  <i class="more__arrow" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="favorites__pagination">
          <div class="favorites__bullets">
            <i class="favorites__line favorites__line--base" />
            <i class="favorites__line favorites__line--main" :style="{transform:'scale('+lineScale+',1)',transitionDuration:lineDuration+'ms'}"
            />
            <div class="favorites__bullet bullet" v-for="(favorite, f) in favoriteItems"
              :key="'bullet'+f" :class="{'is-active':activeSlide===f,'is-visited':f<activeSlide,'is-forward':f>activeSlide}"
              @click="slideTo(f)">
              <i class="bullet__icon" />
              <span class="bullet__text" v-text="favorite.title_repeater" />
            </div>
          </div>
        </div>
        <div class="favorites__nav favorites__nav--prev bullet"
          v-show="activeSlide!==0">
          <i class="bullet__icon" />
        </div>
        <div class="favorites__nav favorites__nav--current bullet is-active">
          <i class="bullet__icon" />
          <span class="bullet__text" v-text="favoriteItems[activeSlide]['title_repeater']"
          />
        </div>
        <div class="favorites__nav favorites__nav--next bullet"
          v-show="activeSlide!==favoriteItems.length-1">
          <i class="bullet__icon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'

export default {
  name: 'Favorites',
  props: ['page'],
  data() {
    return {
      swipeSpeed: 1200,
      heading: null,
      more_label: null,
      swiper: {},
      activeSlide: 0,
      activeTitle: '',
      swiperTimer: null,
      timerSpeed: 4000,
      slideCount: 0,
      favoriteItems: [],
      swiperReady: false,
      lineScale: 0,
      lineDuration: 0,
      debouncedHeight: 0,
      heightTimeout: null
    }
  },
  computed: {
    activeColor() {
      if (this.favoriteItems.length && Object.keys(this.swiper).length) {
        var color = this.favoriteItems[this.swiper.activeIndex]['color']
        return {
          backgroundColor: color
        }
      }
    },
    height: {
      get() {
        return this.debouncedHeight
      },
      set(val) {
        if (this.timeout) clearTimeout(this.timeout)
        this.heightTimeout = setTimeout(() => {
          this.debouncedHeight = val
        }, 0)
      }
    }
  },
  methods: {
    resizeHandler(e) {
      this.height = document.querySelector('.favorite__image__wrapper').offsetHeight
    },
    initFavoritesSwiper() {
      this.swiper = new Swiper(this.$refs['favoritesSlider'], {
        swipeSpeed: this.swipeSpeed,
        simulateTouch: false,
        slideActiveClass: 'is-active',
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0,
          depth: 300,
          stretch: 0,
          modifier: 1,
          slideShadows: false
        },
        on: {
          init: () => {
            this.swiperReady = true
            this.startTimer()
          },
          transitionEnd: () => {
            this.activeSlide = this.swiper.activeIndex
          }
        },
        navigation: {
          nextEl: '.favorites__nav--next',
          prevEl: '.favorites__nav--prev'
        }
      })
    },
    slideTo(f) {
      clearInterval(this.swiperTimer)
      var partSize = 1 / (this.slideCount - 1)
      var targetPart = f
      this.lineScale = targetPart * partSize
      this.lineDuration = this.swipeSpeed
      this.swiper.slideTo(f, this.swipeSpeed)
      this.activeSlide = f
    },
    startTimer() {
      var partSize = 1 / (this.slideCount - 1)
      var targetPart = 1
      var targetSize = targetPart * partSize
      var activeSlide = 0
      this.lineScale = targetSize
      this.lineDuration = this.timerSpeed
      this.swiperTimer = setInterval(() => {
        if (this.activeSlide === this.slideCount - 1) {
          targetPart = 1
          activeSlide = 0
          this.lineScale = 0
          this.lineDuration = 0
          setTimeout(() => {
            this.lineScale = targetPart * partSize
            this.lineDuration = this.timerSpeed
            this.swiper.slideTo(activeSlide, 0)
          }, 0)
        } else {
          if (this.activeSlide !== this.slideCount - 2) {
            targetPart = this.activeSlide + 2
            this.lineScale = targetPart * partSize
            this.lineDuration = this.timerSpeed
          }
          activeSlide++
          this.swiper.slideTo(activeSlide, this.swipeSpeed)
        }
        this.activeSlide = activeSlide
      }, this.timerSpeed)
    }
  },
  beforeMount() {
    this.heading = this.page.favorites_heading
    this.more_label = this.page.favorites_more_label
    this.favoriteItems = this.page.favorites
    this.slideCount = this.favoriteItems.length
    setTimeout(() => {
      this.activeSlide = 0
    }, 1)
  },
  mounted() {
    this.$nextTick(() => {
      this.initFavoritesSwiper()
    })
    this.height = document.querySelector('.favorite__image__wrapper').offsetHeight
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Favorites.vue